/* eslint-disable react/no-array-index-key */
/* eslint-disable security/detect-object-injection */
/* eslint-disable camelcase */
import { useEffect, useRef, useState } from 'react';
import BackgroundWrapper from 'components/Background';
import { useAppDispatch, useAppSelector } from "hooks/store-hooks";
import { updateUserConfigResponse, getAccountInfo } from 'constants/common';
import { DEFAULT_DOMAIN } from 'constants/constant';
import { useNavigate, useParams } from 'react-router-dom';
import { setInsightsToShow } from 'store/slice/conversationSlice';
import { setOutletLoading, setShowInsightsOnUi, setUserChatDetails, setActiveChatId, setActiveChatDetails, setUserInfoDetails } from 'store/slice/userSlice';
import home from 'assets/images/home.png';

function Dashboard() {
  const scrollEndRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const dispatch = useAppDispatch()
  const { outletLoading, user_id, userType, selectedDomain } = useAppSelector((state) => state.user);
  const { chatId } = useParams();
  // const [url, setUrl] = useState("http://4.187.216.183/d/adbp9zt/new-dashboard?orgId=1&kiosk");
  // Updated URL as per your request
  const BASE_URL = "https://insightsagents.tigeranalyticstest.in/admingrafana/d/adbp9zt/new-dashboard?orgId=1";
  // Appending kiosk=true to the base URL
  const [url, setUrl] = useState(`${BASE_URL}&kiosk=true`);
  const scrollToBottom = () => {
    if (scrollEndRef.current) {
      const scrollContainer = scrollEndRef.current;
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }
  };

 const chatInitiationApi = async () => {
    try {
      const payload: any =
      {
        username: user_id,
        domain_name: selectedDomain || DEFAULT_DOMAIN,
        call_ipro: false,
        call_conversation: true,
        call_kb: false,
        call_rag: false,
        call_web_search: false,
        theme: 'light',
        language: 'english',
        update_config: false,
      }
      dispatch(setOutletLoading(true));
      dispatch(setActiveChatDetails({}))
      dispatch(setInsightsToShow({}))
      dispatch(setShowInsightsOnUi(false))
      const response = await updateUserConfigResponse(payload);
      dispatch(setUserChatDetails(response.data));
      localStorage.setItem('convMode', response.data.call_conversation)
      localStorage.setItem('kbMode', response.data.call_kb)
      localStorage.setItem('ragMode', response.data.call_rag)
      localStorage.setItem('webSearchMode', response.data.call_web_search)
      localStorage.setItem('theme', JSON.stringify(response.data.theme))
      localStorage.setItem('language', JSON.stringify(response.data.language.toLowerCase()))
      localStorage.setItem('call_ipro', response.data.call_ipro)
      dispatch(setActiveChatId(!chatId ? 'new' : chatId))

      const accountInfoPayload: any = {
        username: user_id,
      }
      const accountInfoResponse = await getAccountInfo(accountInfoPayload);
      if (accountInfoResponse?.data) {
        dispatch(setUserInfoDetails(accountInfoResponse.data));
      }
      dispatch(setOutletLoading(false));
    }
    catch (err) {
      // console.error("Error during chat initiation:", err);
      dispatch(setOutletLoading(false));
    }
  }

  useEffect(() => {
    chatInitiationApi();
  }, [])

  return (
    <BackgroundWrapper>
    {userType === 'admin' ?
      <div className="flex flex-1 flex-col lg:flex-row h-[64px]">
        <div className="flex-1 h-[calc(100vh-64px)] z-50">
        <iframe
          src={url}
          sandbox="allow-scripts allow-forms allow-pointer-lock allow-same-origin"
          title="Dashboard"
          className="w-full h-full border-none pointer-events-auto"
        />
      </div>
      </div>
      :
      <>
      <div className="flex flex-1 flex-col lg:flex-row h-[64px]">
       <img src={home} alt='coming soon' className='m-auto' />
      </div>
      <div
      role="status"
      aria-live="polite"
      className="absolute inset-0 z-40 flex flex-col items-center justify-center gap-4 dark:bg-black/50 rounded-lg p-4 backdrop-blur-[6px]"   
    >
      <div className="flex items-center gap-3">
        <span className="text-[18px]  font-bold text-[#27303A] dark:text-gray-100"/>
      </div>
      </div>
      </>     
    
      }
      
    </BackgroundWrapper>
  )
}

export default Dashboard
